import React, { FunctionComponent, useState } from 'react';

type Props = {
  className: string;
  isNecessary: boolean;
  label: string;
  annotation?: string;
  name: string;
  year: string;
  month: string;
  day: string;
  yearList: (string | number)[];
  dayList: string[]
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  isNecessary,
  label,
  annotation,
  name,
  year,
  month,
  day,
  yearList,
  dayList,
  handleChange,
}) => {
  return (
    <label htmlFor={name} className={className}>
      <span className="label--title">{label}</span>
      {isNecessary && <span className="label--necessary">必須</span>}
      <div className="label--birthday">
        <div className="label--birthday__inner">
          <div className="label--birthday__inner__date">
            <select onChange={handleChange} className="year select" name="year" value={year}>
              {yearList.map((y) => (
                <option key={y} value={y} disabled={y === '西暦'}>
                  {y}
                </option>
              ))}
            </select>
            <span>年</span>
          </div>
          <div className="label--birthday__inner__date">
            <select onChange={handleChange} className="month select" name="month" value={month}>
              <option value="月" disabled hidden>
                月
              </option>
              {[...Array(12)].map((_, i) => (
                <option value={i + 1} key={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
            <span>月</span>
          </div>
          <div className="label--birthday__inner__date">
            <select onChange={handleChange} className="day select" name="day" value={day}>
              <option value="日" disabled hidden>
                日
              </option>
              {dayList.map((d) => (
                <option value={d} key={d}>
                  {d}
                </option>
              ))}
            </select>
            <span>日</span>
          </div>
        </div>
      </div>
      {annotation !== '' && <p className="label--annotation">{annotation}</p>}
    </label>
  );
};
